/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserDetail,
    ElementsUserDetailFromJSON,
    ElementsUserDetailFromJSONTyped,
    ElementsUserDetailToJSON,
} from './';

/**
 * 
 * @export
 * @interface AuthLoginEndpointResponse
 */
export interface AuthLoginEndpointResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthLoginEndpointResponse
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLoginEndpointResponse
     */
    detail?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLoginEndpointResponse
     */
    redirect?: string;
    /**
     * 
     * @type {ElementsUserDetail}
     * @memberof AuthLoginEndpointResponse
     */
    user: ElementsUserDetail;
    /**
     * 
     * @type {string}
     * @memberof AuthLoginEndpointResponse
     */
    sessionKey?: string;
}

export function AuthLoginEndpointResponseFromJSON(json: any): AuthLoginEndpointResponse {
    return AuthLoginEndpointResponseFromJSONTyped(json, false);
}

export function AuthLoginEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthLoginEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'detail': !exists(json, 'detail') ? undefined : json['detail'],
        'redirect': !exists(json, 'redirect') ? undefined : json['redirect'],
        'user': ElementsUserDetailFromJSON(json['user']),
        'sessionKey': !exists(json, 'session_key') ? undefined : json['session_key'],
    };
}

export function AuthLoginEndpointResponseToJSON(value?: AuthLoginEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reason': value.reason,
        'detail': value.detail,
        'redirect': value.redirect,
        'user': ElementsUserDetailToJSON(value.user),
        'session_key': value.sessionKey,
    };
}


